(function($){

  $(document).ready(function() {
    // Handler for .ready() called.
    $('a[href="#my-paw-friend"]').click(function(event) {
      event.preventDefault(); // Prevent default link behavior.
      var offset = $('#my-paw-friend').offset().top - 180; // Calculate offset with top offset of 90px.
      $('html, body').animate({
        scrollTop: offset
      }, 500); // Scroll animation with a duration of 500ms.
    });
  });

})(jQuery);
